import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { filter, skip } from 'rxjs/operators';
// import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  text = '';
  msg = '';

  constructor(
    private authService: AuthService, 
    private router: Router
  ) {}

  ngOnInit() {
    {
      // Only subscribe to future authentication changes
      this.authService.isAuthenticated$.pipe(
        // Skip the initial value
        skip(1)
      ).subscribe(isAuthenticated => {
        if (isAuthenticated) {
          console.log('User is authenticated, fetching drivers...');
        }
      });
    }
  }
}